module.exports = __webpack_public_path__ + "img/立即订购arrow.f361fb2b.svg";